import Radio from '../Radio/Radio'
import Tooltip from '../Tooltip/Tooltip'
import classes from './LabeledRadio.module.scss'

export interface Props{
  isChecked?: boolean
  isDisabled?: boolean
  label: string
  onChange: (value: any) => void
  tooltip?: string
  value?: string
  variant?: 'page' | 'slider'
}

const LabeledRadio = ({
  label,
  isChecked = false,
  isDisabled = false,
  onChange,
  tooltip,
  value,
  variant = 'page'
}: Props) => {
  const getClasses = () => {
    const baseClass = classes.LabeledRadio

    const isCheckedClass = isChecked
      ? classes.isChecked
      : ''

    const isDisabledClass = isDisabled
      ? classes.Disabled
      : ''

    const isCheckedIsDisabled = isChecked && isDisabled
      ? classes.isCheckedAndIsDisabled
      : ''

    const isUnCheckedAndIsDisabled = !isChecked && isDisabled
      ? classes.isUnCheckedAndIsDisabled
      : ''

    const isDarkerBackgroundInDarkModeClass = variant === 'slider'
      ? classes.isDarkerBackgroundInDarkMode
      : ''

    const finalClasses = [
      baseClass,
      isCheckedClass,
      isDisabledClass,
      isCheckedIsDisabled,
      isUnCheckedAndIsDisabled,
      isDarkerBackgroundInDarkModeClass
    ].filter(classname => classname)

    return finalClasses.join(' ')
  }

  const renderRadioButton = () => (
    <Radio
      isChecked={isChecked}
      isDisabled={isDisabled}
      onChange={onChange}
      value={value}
    />
  )

  return (
    <label className={getClasses()}>
      {
        tooltip
          ? (
            <>
              {renderRadioButton()}
              <Tooltip label={tooltip}>
                {label}
              </Tooltip>
            </>
          )
          : (
            <>
              {renderRadioButton()}
              {label}
            </>
          )
      }
    </label>
  )
}

export default LabeledRadio
